import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import type { CreatePaymentMethodData, StripeError } from "@stripe/stripe-js";
import { useMutation } from "@tanstack/react-query";

import { ExpectedStripeError } from "@/shared/lib";

const isExpectedStripeError = (error: StripeError) =>
  error.type === "validation_error" || error.type === "card_error";

export const useCreatePaymentMethod = () => {
  const stripe = useStripe();
  const elements = useElements();
  const cardElement = elements?.getElement(CardElement);

  return useMutation({
    mutationFn: async (
      billingDetails?: CreatePaymentMethodData["billing_details"],
    ) => {
      if (!stripe || !cardElement) {
        throw new Error();
      }

      const result = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: billingDetails,
      });

      if (result.error) {
        if (isExpectedStripeError(result.error)) {
          throw new ExpectedStripeError(result.error.message ?? "");
        }

        throw new Error(result.error.message);
      }

      return result.paymentMethod.id;
    },
  });
};
